export const getTranslations = t => {
  return {
    search: t("kf.pdp.label.searchBtn", "Search"),
    signIn: t("kf.loggedin.button.signIn", "Sign In"),
    or: t("kf.global.label.or", "or"),
    createCartAccount: t(
      "kf.cart.label.createCartAccount",
      "Create an Account"
    ),
    saveYourCart: t(
      "kf.cart.label.saveYourCart",
      "to save your cart indefinitely."
    ),
    needHelpOrder: t(
      "kf.cart.label.needHelpOrder",
      "Need help with you order?"
    ),
    callSupport: t("kf.cart.label.callSupport", "Call Support"),
    serviceAvailableTitleUpSell: t(
      "kf.upSellRecommended.serviceAvailableTitleUpSell",
      "Add an Install Service"
    ),
    recommendationTitle: t(
      "kf.upSellRecommended.recommendationTitle",
      "We recommend"
    ),
    includeTitle: t("kf.upSellRecommended.includeTitle", "Include"),
    outOfStockTitle: t("kf.upSellRecommended.outOfStockTitle", "Out of Stock"),
    selectedTitle: t("kf.upSellRecommended.selectedTitle", "Selected"),
    arrowLabel: t("kf.upSellRecommended.arrowLabel", "Next"),
    recommendedAdditions: t(
      "kf.upSellRecommended.recommendedAdditions",
      "Recommended Additions"
    ),
  }
}
